import classNames from 'classnames'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import WaitlistActions from './WaitlistActions'
import ProfileOverview from './ProfileOverview'
import WaitlistViewAllModal from './modals/WaitlistViewAllModal'

import { selectWaitlist } from '../../../../../reducers/programDashboardReducer'

import classes from './WaitlistTable.module.scss'

const WaitlistTable = () => {
  const waitlist = useSelector(selectWaitlist)
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <div className={classNames('d-flex flex-column pt-2 pb-1', classes.wrapper)}>
      {waitlist.map(waitlistEntry => (
        <div className={classNames('d-flex align-items-center my-2', classes.table)} key={waitlistEntry.id}>
          <ProfileOverview student={waitlistEntry.user} invitationStatus={waitlistEntry.courseInvitationStatus} />
          <WaitlistActions waitlistEntry={waitlistEntry} />
        </div>
      ))}
      <button
        className={classes.viewAllButton}
        onClick={() => setIsModalOpen(true)}
      >
        View all Details
      </button>
      <WaitlistViewAllModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        waitlist={waitlist}
      />
    </div>
  )
}

export default WaitlistTable


